export const ADMIN_BROWSE_SECTION_TYPE = {
  CATALOG_TITLES: 'catalog-titles',
  LINKS: 'links',
  LISTS: 'lists',
  LISTS_HERO: 'lists-hero',
  LIST_TITLES: 'list-titles',
  NAVIGATION: 'navigation'
};

export const DEFAULT_LINK_VALIDATION = {
  isValid: true,
  errorByAttribute: {
    label: '',
    url: ''
  }
};

export const EMPTY_LIST_URL = {
  title: '',
  url: ''
};

export const EMPTY_SECTION_BY_ADMIN_BROWSE_SECTION_TYPE = {
  [ADMIN_BROWSE_SECTION_TYPE.CATALOG_TITLES]: {
    hasAlternativeBackground: false,
    heading: '',
    searchUrl: '',
    sectionType: ADMIN_BROWSE_SECTION_TYPE.CATALOG_TITLES
  },
  [ADMIN_BROWSE_SECTION_TYPE.LINKS]: {
    hasAlternativeBackground: false,
    heading: '',
    links: [],
    sectionType: ADMIN_BROWSE_SECTION_TYPE.LINKS
  },
  [ADMIN_BROWSE_SECTION_TYPE.LISTS]: {
    hasAlternativeBackground: false,
    heading: '',
    listUrls: [],
    sectionType: ADMIN_BROWSE_SECTION_TYPE.LISTS
  },
  [ADMIN_BROWSE_SECTION_TYPE.LISTS_HERO]: {
    listUrls: [],
    sectionType: ADMIN_BROWSE_SECTION_TYPE.LISTS_HERO
  },
  [ADMIN_BROWSE_SECTION_TYPE.LIST_TITLES]: {
    hasAlternativeBackground: false,
    listUrl: EMPTY_LIST_URL,
    sectionType: ADMIN_BROWSE_SECTION_TYPE.LIST_TITLES
  },
  [ADMIN_BROWSE_SECTION_TYPE.NAVIGATION]: {
    links: [],
    sectionType: ADMIN_BROWSE_SECTION_TYPE.NAVIGATION
  }
};

export const LISTS_NUM_MIN_LIST_URLS = 2;
export const LISTS_NUM_MAX_LIST_URLS = 4;

export const LISTS_HERO_NUM_MIN_LIST_URLS = 3;
export const LISTS_HERO_NUM_MAX_LIST_URLS = 5;

export const NUM_MAX_LINKS = 12;

export const VALIDATION_ERROR_MESSAGE = {
  INVALID_CATALOG_SEARCH_URL: 'A catalog search URL is required',
  INVALID_HEADING: 'A heading is required',
  INVALID_LABEL: 'A label is required',
  INVALID_LIST_URL: 'A List URL is required',
  INVALID_URL: 'A URL is required'
};
